module.exports = __webpack_public_path__ + "img/hexagon-minus.7936db78.svg";